import { getLocalizedArray, onTranslationsApplied } from './localization.ts';

const PERSONAL_NOTE_ROTATOR_FALLBACK = [
  'gadgets',
  'phone',
  'attention',
  'social media',
  'computer',
  'emails',
  'tech',
  'news',
  'ads',
];

let personalNoteRotatorInterval: number | null = null;

function stopPersonalNoteRotator(): void {
  if (personalNoteRotatorInterval !== null) {
    clearInterval(personalNoteRotatorInterval);
    personalNoteRotatorInterval = null;
  }
}

function getPersonalNoteRotatingItems(): unknown[] {
  return getLocalizedArray('slides.personalNote.rotatingItems', PERSONAL_NOTE_ROTATOR_FALLBACK);
}

function initPersonalNoteRotator(): void {
  const rotator = document.querySelector('.personal-note-rotator');
  stopPersonalNoteRotator();

  if (!rotator) {
    return;
  }

  const items = getPersonalNoteRotatingItems();
  if (!items.length) {
    rotator.textContent = '';
    return;
  }

  rotator.setAttribute('aria-live', 'polite');
  rotator.setAttribute('aria-atomic', 'true');

  let index: number = 0;
  const setItem = (): void => {
    const next = items[index];
    rotator.textContent = String(next);
    index = (index + 1) % items.length;
  };

  setItem();

  personalNoteRotatorInterval = window.setInterval(setItem, 1600);
}

function initPersonalNote(): void {
  initPersonalNoteRotator();
  onTranslationsApplied(() => {
    initPersonalNoteRotator();
  });
}

export { initPersonalNote, initPersonalNoteRotator, stopPersonalNoteRotator };
